import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import thunkMiddleware from 'redux-thunk'

// import { persistStore, persistReducer } from 'redux-persist'

// import storage from 'redux-persist/lib/storage'

import { accessReducer } from './reducers/access'
import { appReducer } from './reducers/app'
import { authReducer } from './reducers/auth'
import { classEntityReducer } from './reducers/classEntity'
import { commonReducer } from './reducers/common'
import { communicationEntityReducer } from './reducers/communicationEntity'
import { communityEntityReducer } from './reducers/communityEntity'
import { demoSchedulingReducer } from './reducers/demoScheduling'
import { eventEntityReducer } from './reducers/eventEntity'
import { lessonPlannerEntityReducer } from './reducers/lessonPlannerEntity'
import { ordersEntityReducer } from './reducers/ordersEntity'
import { paymentEntityReducer } from './reducers/paymentEntity'
import { preschoolEntityReducer } from './reducers/preschoolEntity'
import { spaceEntityReducer } from './reducers/spaceEntity'
import { userEntityReducer } from './reducers/userEntity'
import { websocketReducer } from './reducers/WebSocket'
import rootSaga from './sagas'

const filterActionPropagation = () => (next) => (action) => {
  if (!action.type.startsWith('HANDLE_')) return next(action)
}

const sagaMiddleware = createSagaMiddleware()

const middlewares = [thunkMiddleware, sagaMiddleware, filterActionPropagation]

const rootReducer = combineReducers({
  accessReducer,
  appReducer,
  classEntityReducer,
  communicationEntityReducer,
  communityEntityReducer,
  demoSchedulingReducer,
  eventEntityReducer,
  ordersEntityReducer,
  paymentEntityReducer,
  preschoolEntityReducer,
  lessonPlannerEntityReducer,
  spaceEntityReducer,
  userEntityReducer,
  authReducer,
  commonReducer,
  websocketReducer
})

const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares))
)

// finally run saga
sagaMiddleware.run(rootSaga)

// const persistor = persistStore(store)

// setting store in global to use it globally
window.reduxStore = store

// export { store, persistor }
export { store }
